import React from 'react';
import { Grid, useMediaQuery } from '@material-ui/core';
import '../App.css';
import GoalAchievementRateBarGraph from './GoalAchievementRateBarGraph';
import PeriodBarGraph from './PeriodBarGraph';
import { currencyStyle } from '../utils/common';

type GraphStatus = {
  date: string;
  target_value: number;
  actual_value: number;
  achievement_rate: number;
};

type GraphStatuses = {
  start_date_year: number;
  start_date_month: number;
  end_date_year: number;
  end_date_month: number;
  target_sales_amount: number;
  target_cost_amount: number;
  target_gross_profit_amount: number;
  target_gross_profit_rate_mean: number;
  target_business_a_cases_num: number;
  target_business_b_cases_num: number;
  target_business_c_cases_num: number;
  target_construction_projects_num: number;
  target_completed_projects_num: number;
  actual_sales_amount: number;
  actual_cost_amount: number;
  actual_gross_profit_amount: number;
  actual_gross_profit_rate_mean: number;
  actual_business_a_cases_num: number;
  actual_business_b_cases_num: number;
  actual_business_c_cases_num: number;
  actual_construction_projects_num: number;
  actual_completed_projects_num: number;
  currency: number;
  max_target_value: number;
  graphStatus: GraphStatus[];
};

const TeamContainer: React.FC<GraphStatuses> = graphStatuses => {
  const matches2 = useMediaQuery('(min-width:900px)');

  return (
    <div className='responsive-container3'>
      <PeriodBarGraph
        start_date_year={graphStatuses.start_date_year}
        start_date_month={graphStatuses.start_date_month}
        end_date_year={graphStatuses.end_date_year}
        end_date_month={graphStatuses.end_date_month}
        actual_sales_amount={graphStatuses.actual_sales_amount}
        max_target_value={graphStatuses.max_target_value}
        currency={graphStatuses.currency}
        graphStatus={graphStatuses.graphStatus}
      />
      <Grid container>
        <Grid className='team-container-cell' item xs={!matches2 ? 6 : 3}>
          <div className='team-container-cell-inner'>
            <div>
              <div>
                <div className='bg-top-container'>
                  <div
                    style={{
                      padding: 15,
                      backgroundColor: '#FFFFFF',
                      marginRight: 10
                    }}
                  >
                    <div className='mg-bottom team-container-graph-text'>
                      売上目標達成率
                    </div>
                    <div className='team-container-graph-percent'>
                      {isNaN(
                        (graphStatuses.actual_sales_amount /
                          graphStatuses.target_sales_amount) *
                          100
                      ) || graphStatuses.target_sales_amount === 0
                        ? 0
                        : (
                            (graphStatuses.actual_sales_amount /
                              graphStatuses.target_sales_amount) *
                            100
                          ).toFixed(1)}{' '}
                      %
                    </div>
                    <div className='mg-bottom team-container-graph-text'>
                      実績:{' '}
                      {currencyStyle(
                        graphStatuses.actual_sales_amount,
                        graphStatuses.currency
                      )}{' '}
                      / 目標:{' '}
                      {currencyStyle(
                        graphStatuses.target_sales_amount,
                        graphStatuses.currency
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <GoalAchievementRateBarGraph
                title=''
                targetValue={graphStatuses.target_sales_amount}
                realValue={graphStatuses.actual_sales_amount}
              />
              <div>
                <div className='bg-top-container'>
                  <div
                    style={{
                      padding: 15,
                      backgroundColor: '#FFFFFF',
                      marginRight: 10
                    }}
                  >
                    <div className='mg-bottom team-container-graph-text'>
                      営業中(ランクA)案件数目標達成率
                    </div>
                    <div className='team-container-graph-percent'>
                      {isNaN(
                        (graphStatuses.actual_business_a_cases_num /
                          graphStatuses.target_business_a_cases_num) *
                          100
                      ) || graphStatuses.target_business_a_cases_num === 0
                        ? 0
                        : (
                            (graphStatuses.actual_business_a_cases_num /
                              graphStatuses.target_business_a_cases_num) *
                            100
                          ).toFixed(1)}{' '}
                      %
                    </div>
                    <div className='mg-bottom team-container-graph-text'>
                      実績: {graphStatuses.actual_business_a_cases_num} 件 /
                      目標: {graphStatuses.target_business_a_cases_num} 件
                    </div>
                  </div>
                </div>
              </div>
              <GoalAchievementRateBarGraph
                title=''
                targetValue={graphStatuses.target_business_a_cases_num}
                realValue={graphStatuses.actual_business_a_cases_num}
              />
            </div>
          </div>
        </Grid>
        <Grid className='team-container-cell' item xs={!matches2 ? 6 : 3}>
          <div className='team-container-cell-inner'>
            <div>
              <div>
                <div className='bg-top-container'>
                  <div
                    style={{
                      padding: 15,
                      backgroundColor: '#FFFFFF',
                      marginRight: 10
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div className='mg-bottom team-container-graph-text'>
                        原価目標超過率
                      </div>
                      <div style={{ color: '#FFFFFF', fontSize: 12 }}>件 </div>
                    </div>
                    <div className='team-container-graph-percent'>
                      {isNaN(
                        (graphStatuses.actual_cost_amount /
                          graphStatuses.target_cost_amount) *
                          100
                      ) || graphStatuses.target_cost_amount === 0
                        ? 0
                        : (
                            (graphStatuses.actual_cost_amount /
                              graphStatuses.target_cost_amount) *
                            100
                          ).toFixed(1)}{' '}
                      %
                    </div>
                    <div className='mg-bottom team-container-graph-text'>
                      実績:{' '}
                      {currencyStyle(
                        graphStatuses.actual_cost_amount,
                        graphStatuses.currency
                      )}{' '}
                      / 目標:{' '}
                      {currencyStyle(
                        graphStatuses.target_cost_amount,
                        graphStatuses.currency
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <GoalAchievementRateBarGraph
                title=''
                targetValue={graphStatuses.target_cost_amount}
                realValue={graphStatuses.actual_cost_amount}
              />
              <div>
                <div className='bg-top-container'>
                  <div
                    style={{
                      padding: 15,
                      backgroundColor: '#FFFFFF',
                      marginRight: 10
                    }}
                  >
                    <div className='mg-bottom team-container-graph-text'>
                      工事案件数目標達成率
                    </div>
                    <div className='team-container-graph-percent'>
                      {isNaN(
                        (graphStatuses.actual_construction_projects_num /
                          graphStatuses.target_construction_projects_num) *
                          100
                      ) || graphStatuses.target_construction_projects_num === 0
                        ? 0
                        : (
                            (graphStatuses.actual_construction_projects_num /
                              graphStatuses.target_construction_projects_num) *
                            100
                          ).toFixed(1)}{' '}
                      %
                    </div>
                    <div className='mg-bottom team-container-graph-text'>
                      実績: {graphStatuses.actual_construction_projects_num} 件
                      / 目標: {graphStatuses.target_construction_projects_num}{' '}
                      件
                    </div>
                  </div>
                </div>
              </div>
              <GoalAchievementRateBarGraph
                title=''
                targetValue={graphStatuses.target_construction_projects_num}
                realValue={graphStatuses.actual_construction_projects_num}
              />
            </div>
          </div>
        </Grid>
        <Grid className='team-container-cell' item xs={!matches2 ? 6 : 3}>
          <div className='team-container-cell-inner'>
            <div>
              <div>
                <div className='bg-top-container'>
                  <div
                    style={{
                      padding: 15,
                      backgroundColor: '#FFFFFF',
                      marginRight: 10
                    }}
                  >
                    <div className='mg-bottom team-container-graph-text'>
                      粗利目標達成率
                    </div>
                    <div className='team-container-graph-percent'>
                      {isNaN(
                        (graphStatuses.actual_gross_profit_amount /
                          graphStatuses.target_gross_profit_amount) *
                          100
                      ) || graphStatuses.target_gross_profit_amount === 0
                        ? 0
                        : (
                            (graphStatuses.actual_gross_profit_amount /
                              graphStatuses.target_gross_profit_amount) *
                            100
                          ).toFixed(1)}{' '}
                      %
                    </div>
                    <div className='mg-bottom team-container-graph-text'>
                      実績:{' '}
                      {currencyStyle(
                        graphStatuses.actual_gross_profit_amount,
                        graphStatuses.currency
                      )}{' '}
                      / 目標:{' '}
                      {currencyStyle(
                        graphStatuses.target_gross_profit_amount,
                        graphStatuses.currency
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <GoalAchievementRateBarGraph
                title=''
                targetValue={graphStatuses.target_gross_profit_amount}
                realValue={graphStatuses.actual_gross_profit_amount}
              />
              <div>
                <div className='bg-top-container'>
                  <div
                    style={{
                      padding: 15,
                      backgroundColor: '#FFFFFF',
                      marginRight: 10
                    }}
                  >
                    <div className='mg-bottom team-container-graph-text'>
                      完了案件数目標達成率
                    </div>
                    <div className='team-container-graph-percent'>
                      {isNaN(
                        (graphStatuses.actual_completed_projects_num /
                          graphStatuses.target_completed_projects_num) *
                          100
                      ) || graphStatuses.target_completed_projects_num === 0
                        ? 0
                        : (
                            (graphStatuses.actual_completed_projects_num /
                              graphStatuses.target_completed_projects_num) *
                            100
                          ).toFixed(1)}{' '}
                      %
                    </div>
                    <div className='mg-bottom team-container-graph-text'>
                      実績: {graphStatuses.actual_completed_projects_num} 件 /
                      目標: {graphStatuses.target_completed_projects_num} 件
                    </div>
                  </div>
                </div>
              </div>
              <GoalAchievementRateBarGraph
                title=''
                targetValue={graphStatuses.target_completed_projects_num}
                realValue={graphStatuses.actual_completed_projects_num}
              />
            </div>
          </div>
        </Grid>
        <Grid className='team-container-cell' item xs={!matches2 ? 6 : 3}>
          <div className='team-container-cell-inner'>
            <div>
              <div>
                <div className='bg-top-container'>
                  <div
                    style={{
                      padding: 15,
                      backgroundColor: '#FFFFFF',
                      marginRight: 10
                    }}
                  >
                    <div className='mg-bottom team-container-graph-text'>
                      粗利率目標達成率
                    </div>
                    <div className='team-container-graph-percent'>
                      {isNaN(
                        (graphStatuses.actual_gross_profit_rate_mean /
                          graphStatuses.target_gross_profit_rate_mean) *
                          100
                      ) || graphStatuses.target_gross_profit_rate_mean === 0
                        ? 0
                        : (
                            (graphStatuses.actual_gross_profit_rate_mean /
                              graphStatuses.target_gross_profit_rate_mean) *
                            100
                          ).toFixed(1)}{' '}
                      %
                    </div>
                    <div className='mg-bottom team-container-graph-text'>
                      実績: {graphStatuses.actual_gross_profit_rate_mean} % /
                      目標: {graphStatuses.target_gross_profit_rate_mean} %
                    </div>
                  </div>
                </div>
              </div>
              <GoalAchievementRateBarGraph
                title=''
                targetValue={graphStatuses.target_gross_profit_rate_mean}
                realValue={graphStatuses.actual_gross_profit_rate_mean}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
export default TeamContainer;
